export const MATERIAL_MAPPING = { //Just to keep an overview what key belongs to what
    ID : 0,   // ID in der Datenbank
    NAME : 1,   // Name
    MAT_NAME : 2,   // Materialname
    MAT_DESC : 3,   // Materialbeschreibung
    COL_NAME : 4,   // Name der Farbe
    COL_TYPE : 5,   // Farbtyp (Monochrom-RGB, Vollfarbe, Metall)
    COL_RGB : 6,   // RGB-Farbwertdarstellung
    PRICE_P0 : 7 ,   // Preisparameter P0
    PRICE_PMIN : 8,   // Preisparameter Pmin
    PRICE_A : 9,   // Preisparameter a [EUR/cm3]
    PRICE_B : 10,  // Preisparameter b [EUR/cm(3*q)]
    PRICE_C : 11,  // Preisparameter c [EUR/cm(3*q)]
    MINIMAL_VOLUME : 12,  // Preisparameter V1 [cm3]
    PRICE_Q : 13,  // Preisparameter q
    PRICE_ALPHA : 14,  // Preisparameter alpha;
    PRICE_BETA : 15,  // Preisparameter beta;
    IMG : 16,  // Vorschaubild-Datei
    IMG_GRY : 17,  // Vorschaubild-Datei in Schwarzweiss
    RES_X_Y : 18,  // Aufloesung XY [mm]
    RES_Z : 19,  // Aufloesung Z [mm]
    MIN_FEAT_SIZE : 20,  // Minimale Feature-Groesse [mm]
    MAX_DIM_X : 21,  // Max. Dim. X [cm]
    MAX_DIM_Y : 22,  // Max. Dim. Y [cm]
    MAX_DIM_Z :23,  // Max. Dim. Z [cm]
    DELIVERY_TIME : 24,  // Lieferdauer [d]
    COMBINED_PRINTING_MODE_ID : 25,  // Combined Printing Mode ID
    PREV_IMG_NAME: 26,  // Name of the preview image
    I18N_OBJECT: 27,    //Object for the I18N strings
}